import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=48c355b4&scoped=true"
import script from "./FooterToolBar.vue?vue&type=script&lang=js"
export * from "./FooterToolBar.vue?vue&type=script&lang=js"
import style0 from "./FooterToolBar.vue?vue&type=style&index=0&id=48c355b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c355b4",
  null
  
)

export default component.exports